import '../css/style.css';
console.log('Picosecond Tech System Initialized');
